import { gql } from '@apollo/client';
import { CAMPAIGN_FRAGMENT } from '../fragments/campaign.newsletter.graphql';

export const UPSERT_CAMPAIGN_MUTATION = gql`
  mutation UpsertCampaign(
    $where: CampaignWhereUniqueInput!
    $create: CampaignCreateInput!
    $update: CampaignUpdateInput!
  ) {
    upsertCampaign(create: $create, update: $update, where: $where) {
      ...Campaign
    }
  }
  ${CAMPAIGN_FRAGMENT}
`;
